import { useQuery } from '@tanstack/react-query';
import { toastErrorConfig } from 'lib/reactToastify/config';
import { toast } from 'react-toastify';

import { queryKeys } from 'api/config';
import { logError } from 'lib/sentry/logError';
import { useQueryHTTPRequest } from 'shared_DEPRECATED/hooks';

import { Tool } from 'features/sessions/config/types';

export const useCoachingToolsQuery = () => {
  const { request } = useQueryHTTPRequest();

  return useQuery<{ coachingTools: Tool[] }, unknown, Tool[]>(
    [queryKeys.coachingTools],
    () => request({ url: '/api/bootstrap' }),
    {
      select: (data) =>
        Array.isArray(data.coachingTools)
          ? data.coachingTools.filter((item) => item.value && item.label)
          : [],
      staleTime: Infinity,
      onError: (error) => {
        toast.error(
          "There's an error with fetching coaching tools. Please try again later.",
          toastErrorConfig
        );
        logError(error);
      },
    }
  );
};
